export default __webpack_public_path__ + "static/media/image35tum.40af206c.jpg";